import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslations } from 'hooks/useTranslations';
import { EMarkingTypes } from 'constants/Markings';
import { FormInput } from 'components/molecules/FormInput';
import { IFormElementProps } from 'models/form';
import { MarkingTypes } from 'pages/LegalEntitiesPage/LegalEntityAddTransactionForGroupPage';

interface IMarking {
  uniqueId: string;
  marking: string;
  markingType: EMarkingTypes;
  createdDate: string;
}

interface IItem {
  markings: IMarking[] | null;
  wasImported: Boolean;
}

interface IMarkingsForm extends IFormElementProps {
  items?: IItem[];
  index?: number;
  item?: IItem | null;
  isGroupTransaction: boolean;
  setValue: any;
  [key: string]: any;
}

const MarkingsFormForMarked = ({
  items = [],
  item,
  index,
  isGroupTransaction,
  setValue,
  control,
  errors,
  name,
  required = true,
  ...params
}: IMarkingsForm) => {
  const { t } = useTranslations();

  const isDifferentMarkingsInitialTrx = !(
    items?.length && items?.filter((frm) => frm?.wasImported)?.length === items?.length
  );

  const showImportMarking =
    item?.wasImported &&
    !item?.markings?.find((mar) => mar.markingType === EMarkingTypes.IMPORT);

  const markingType: MarkingTypes = showImportMarking
    ? MarkingTypes.IMPORT
    : MarkingTypes.APPLIED;

  useEffect(() => {
    if (item) {
      setValue(`${name}Type`, markingType);
    }
  }, [item]);

  if (!isGroupTransaction && item) {
    return (
      <>
        {showImportMarking ? (
          <FormInput
            name={name}
            label={t('addFirearm.firearmList.section.importMarking.label')}
            setValue={setValue}
            control={control}
            errors={errors}
            required={required}
            {...params}
          />
        ) : (
          <FormInput
            name={name}
            label={t('addTransaction.document.section.markedMarking.label')}
            control={control}
            setValue={setValue}
            errors={errors}
            required={required}
            {...params}
          />
        )}
      </>
    );
  }
  if (isGroupTransaction) {
    return (
      <>
        {(showImportMarking || isDifferentMarkingsInitialTrx) && (
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <FormInput
              defaultValue={
                !showImportMarking
                  ? (item?.markings?.find((mar) => mar.markingType === EMarkingTypes.IMPORT)
                      ?.marking ?? t('addTransaction.document.section.notApplicable.label'))
                  : undefined
              }
              name={!showImportMarking ? 'importMarking' : name}
              label={t('addFirearm.firearmList.section.importMarking.label')}
              control={control}
              errors={errors}
              arrayName="markings"
              arrayIndex={index}
              fieldName="marking"
              disabled={!showImportMarking}
              {...params}
            />
          </Grid>
        )}
        {(!showImportMarking || isDifferentMarkingsInitialTrx) && (
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <FormInput
              defaultValue={
                showImportMarking
                  ? (item?.markings?.find((mar) => mar.markingType === EMarkingTypes.APPLIED)
                      ?.marking ?? '')
                  : undefined
              }
              name={showImportMarking ? 'appliedMarking' : name}
              label={t('addTransaction.document.section.markedMarking.label')}
              control={control}
              errors={errors}
              arrayName="markings"
              arrayIndex={index}
              fieldName="marking"
              disabled={showImportMarking}
              {...params}
            />
          </Grid>
        )}
      </>
    );
  }
};
export { MarkingsFormForMarked };
